export default __webpack_public_path__ + "static/media/btn-youtube.42ab32ca.webp";